import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './app/store';
import reportWebVitals from './reportWebVitals';

// Lazy import to load faster and avoid using wrong scss.
const App = lazy(() => import('./App'));
const CtnApp = lazy(() => import('./overrides/ctn/CtnApp'));
const EdwApp = lazy(() => import('./overrides/edw/EdwApp'));
const BtiApp = lazy(() => import('./overrides/bti/BtiApp'));
const CypApp = lazy(() => import('./overrides/cyp/CypApp'));

// If you want your app to work offline and load faster, add these line
//
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// serviceWorkerRegistration.register()
//
// Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//
// NOTE: To make service worker run in local, make sure you use "npm run build"
// and ask Google to treat the local domain as secure in chrome://flags/#unsafely-treat-insecure-origin-as-secure
// link: https://stackoverflow.com/questions/52299246/cant-find-serviceworker-in-navigator-anymore

const getApp = () => {
  switch (import.meta.env.VITE_APP_CUSTOMER) {
    case 'CYP':
      return <CypApp />;
    case 'CTN':
      return <CtnApp />;
    case 'EDW':
      return <EdwApp />;
    case 'BTI':
      return <BtiApp />;
    case 'BWA':
      return <App />;
    default:
      return <App />;
  }
};

let root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={null}>{getApp()}</Suspense>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
